import * as yup from 'yup';

export const logInSchema : any = yup.object().shape({
    email: yup.string().required('PUBLIC.LOG_IN.ERROR_MESSAGE.EMAIL_REQUIRED').email('PUBLIC.LOG_IN.ERROR_MESSAGE.INVALID_EMAIL'),
    password:yup.string().required('PUBLIC.LOG_IN.ERROR_MESSAGE.PASSWORD_REQUIRED')
});

export const createApplicationsSchema : any = yup.object().shape({
    application_name: yup.string().required('Application Name required'),
    application_color:yup.string().required('Application Color required')
});